import productTypeApi from '../../api/productType';
import _ from 'lodash';

const updateInterval = 3600; //1 hour
let refreshPromise = null;

export default {
    namespaced: true,
    state: {
        productTypes: [],
        lastUpdate: 0,
    },
    getters: {
        getProductTypeById: (state) => (id) => {
            return state.productTypes.find((x) => x.producttypeId == id);
        },
        getProductTypes(state) {
            return state.productTypes;
        },
        getProductTypesByOrderType: (state) => (orderType) => {
            const productTypes = state.productTypes.filter(
                (x) => x.orderType == orderType && x.active
            );
            return _.sortBy(productTypes, (x) => parseInt(x.sortBy));
        },
    },
    actions: {
        refreshProductTypesDelayed({ dispatch }, params) {
            if (
                window.newVueApp &&
                window.newVueApp.$route &&
                window.newVueApp.$route.path != '/login'
            ) {
                _.debounce(() => {
                    dispatch('refreshProductTypes', {
                        config: { onBackground: true },
                        params: params,
                    });
                }, params.debounceTime || 1000)();
            }
        },
        refreshProductTypes({ state, getters }, {config, params}) {
            config = config || {};
            params = params || {};

            const forceCheck = params.forceCheck || false;
            const onBackground = config.onBackground || false;

            if (!forceCheck) {
                const currentSeconds = new Date().getTime() / 1000;
                const secondsPassed = currentSeconds - state.lastUpdate;
                if (secondsPassed < updateInterval) {
                    return Promise.resolve();
                }
            }

            if (refreshPromise) {
                return refreshPromise;
            }

            refreshPromise = new Promise(function (resolve, reject) {
                productTypeApi
                    .getProductTypes(
                        productTypeApi.PRODUCTTYPE_ACTIVE_AND_INACTIVE,
                        onBackground
                    )
                    .then((response) => {
                        const allShortTypes = response.data.data;

                        // Determine which product types need to be fetched
                        // (those not in cache or with updated version)
                        const idsToFetch = allShortTypes
                            .filter((shortType) => {
                                const existingType = getters.getProductTypeById(
                                    shortType.producttypeId
                                );
                                return (
                                    !existingType ||
                                    existingType.version < shortType.version
                                );
                            })
                            .map((shortType) => shortType.producttypeId);

                        // If nothing changed, resolve immediately
                        if (idsToFetch.length === 0) {
                            resolve();
                            return;
                        }

                        // Fetch all changed product types in a single batch call
                        productTypeApi
                            .getAllProductTypesDetails(idsToFetch, onBackground)
                            .then((response) => {
                                const updatedTypes = response.data.data;

                                // Update cache: filter out old versions and add new ones
                                let newProductTypes = state.productTypes.filter(
                                    (existing) =>
                                        !idsToFetch.includes(
                                            existing.producttypeId
                                        )
                                );
                                newProductTypes = newProductTypes.concat(
                                    updatedTypes
                                );

                                state.productTypes = newProductTypes;
                                resolve();
                            })
                            .catch(() => {
                                reject();
                            });
                    })
                    .catch(() => {
                        reject();
                    })
            });

            return refreshPromise.then(
                () => {
                    state.lastUpdate = new Date().getTime() / 1000;
                    refreshPromise = null;
                },
                () => {
                    refreshPromise = null;
                }
            );
        },
    },
};
